import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import * as groupActions from 'PointOfSale/modules/group/state/actions';
import * as individualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import GroupTeacherServing from 'PointOfSale/modules/groupTeacher/component/GroupTeacherServing';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';

class GroupServingContainer extends Component {
  componentDidMount() {
    const { Id, profiles } = this.props;
    if (Id && (!profiles || !profiles.length)) {
      this.props.groupActions.fetchProfiles(Id);
    }
  }

  onSelectClick = profile => {
    const { groupActions } = this.props;

    groupActions.toggleProfileSelect(profile.Id);
  };

  onProfileSelect = profile => {
    const { individualServingActions, history } = this.props;
    individualServingActions.setCurrentProfile(profile);
    history.push(`${POS_ROUTES.GROUP}/${profile.Id}`);
  };

  render() {
    return (
      <GroupTeacherServing
        {...this.props}
        onProfileSelect={this.onProfileSelect}
        onSelectClick={this.onSelectClick}
      />
    );
  }
}

GroupServingContainer.propTypes = {
  showLoader: PropTypes.bool,
  Id: PropTypes.number, //TODO based on API change the type to number/string
  profiles: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = state => ({
  showLoader: state.PointOfSaleState.group.showLoader,
  profiles: state.PointOfSaleState.group.profiles,
  Id: state.PointOfSaleState.group.Id,
  isSelectedForCheckout: state.PointOfSaleState.group.isSelectedForCheckout,
});

const mapDispatchToProps = dispatch => ({
  groupActions: bindActionCreators(groupActions, dispatch),
  individualServingActions: bindActionCreators(
    individualServingActions,
    dispatch
  ),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GroupServingContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/container/GroupServingContainer.js